// extracted by mini-css-extract-plugin
export default {"container":"Input_container__R1sF4","label":"Input_label__OxUaY","inputContainer":"Input_inputContainer__CRMWS","icon":"Input_icon__H-e7W","error":"Input_error__8+6jy"};